import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { PATH_HOME } from '../../routes/paths';
import { useSettingsContext } from '../settings';
import { brandConfig } from '../../config';
import { cn } from '../../lib/utils';

// ----------------------------------------------------------------------

export interface LogoProps {
  disabledLink?: boolean;
  full?: boolean;
  height?: number;
  width?: number;
  className?: string;
  onMouseDown?: (event: React.MouseEvent<HTMLElement>) => void;
}

/**
 * @param disabledLink will disable navigation when clicked. Helpful on OOB action pages.
 * @param full will determine which Logo will be shown.
 * @param height vertical size
 * @param width horizontal size
 */
const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, full = false, height, width, className, onMouseDown }, ref) => {
    const { themeMode } = useSettingsContext();

    const logo = !full ? (
      <img
        ref={ref as React.Ref<HTMLImageElement>}
        src={themeMode !== 'dark' ? brandConfig.iconUrl : brandConfig.iconUrlDark}
        alt="Logo"
        onMouseDown={onMouseDown as React.MouseEventHandler<HTMLImageElement>}
        style={{
          width: width || 40,
          height: height || 40
        }}
        className={cn('inline-flex', className)}
      />
    ) : (
      <img
        ref={ref as React.Ref<HTMLImageElement>}
        src={themeMode !== 'dark' ? brandConfig.logoUrl : brandConfig.logoUrlDark}
        alt="Logo"
        onMouseDown={onMouseDown as React.MouseEventHandler<HTMLImageElement>}
        style={{
          width: width || 240
        }}
        className={cn('inline-flex cursor-pointer', className)}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <NavLink to={PATH_HOME.root} className="contents cursor-pointer">
        {logo}
      </NavLink>
    );
  }
);

Logo.displayName = 'Logo';

export default Logo;
